import { createSlice } from '@reduxjs/toolkit';

const personalDetailsSlice = createSlice({
  name: 'personalDetails',
  initialState: {
    startCapture: false,
    capturedImage: null,
    missingDetails: null,
    pageerror: null,
    fileerror: null,
    fileData: null,
    selectedDocType: null,
    isUploadModalOpen: false,
    uploadedImage: ''
  },
  reducers: {
    setStartCapture: (state, action) => {
      state.startCapture = action.payload;
    },
    setCapturedImage: (state, action) => {
      state.capturedImage = action.payload;
    },
    setPageError: (state, action) => {
      state.pageerror = action.payload;
    },
    setMissingDetails: (state, action) => {
      state.missingDetails = action.payload;
    },
    setSelectedDocType: (state, action) => {
      state.selectedDocType = action.payload;
    },
    openUploadModal: (state) => {
      state.isUploadModalOpen = true;
    },
    closeUploadModal: (state) => {
      state.fileData = ''
      state.isUploadModalOpen = false;
    },
    setFileError: (state, action) => {
      state.fileerror = action.payload;
    },
    setFileData: (state, action) => {
      state.fileData = action.payload;
    },
    setUploadedFile: (state, action) => {
      state.uploadedImage = action.payload;
    },
  },
});

export const { setStartCapture, setCapturedImage, setPageError, setMissingDetails, setSelectedDocType, openUploadModal, closeUploadModal, setFileError, setFileData, setUploadedFile } = personalDetailsSlice.actions;
export default personalDetailsSlice.reducer;
